import { get, post } from '@/utils/http/IRequest'
import { CaptchaRes, LoginInfo, ResetReq, RestPswReq } from "@/interface/account";

// 登陆
export const userLogin = (data: LoginInfo) => post<any>('/auth/api/login', data, {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// 退出登陆
export const userLogout = () => get('/auth/api/logout')

// 获取验证码
export const getCaptcha = () => get<CaptchaRes>('/auth/api/getCaptcha')
// 获取短信验证码
export const getSMS = (username: string) => get('/auth/api/captcha/sms', { phone: username })

// 获取登录状态
export const getUserLogin = () => get<boolean>('/auth/api/loggedIn')

// 获取用户信息
export const getUserInfo = () => get<string>('/auth/api/username')

// 获取重置密码的验证码
export const getResetPsw = (params: ResetReq) => get('/auth/api/captcha/reset', { ...params })

// 重置密码
export const pswReset = (data: RestPswReq) => post('/auth/api/password/reset', data, {})

// 获取登录图形验证码信息
export const getCaptchaInfo = () => get<string>('/auth/api/captcha')

// 获取用户支持的MFA方式
export const getMfaSupportedList = (params: { tempAuthId: string }) => get<Record<string, string>>('/auth/api/mfa/supported', { ...params })

// 发送短信MFA验证码
export const sendSMSMfaCode = (data: { tempAuthId: string }) => post('/auth/api/mfa/sms/send', data)

// 发送邮箱MFA验证码
export const sendEmailMfaCode = (data: { tempAuthId: string }) => post('/auth/api/mfa/email/send', data)

// 绑定TOTP
export const bindMfaTotp = (data: { tempAuthId: string }) => post('/auth/api/mfa/totp/setup', data)

// 验证绑定TOTP
export const verifyBindMfaTotp = (data: { tempAuthId: string, code: string }) => post('/auth/api/mfa/totp/verify', data)

// 验证三种方式提交
export const verifyMfa = (data: any) => post('/auth/api/mfa/verify', data)
